
// 测试域名 https://66.xiaobu.vip

const host = process.env.NODE_ENV === 'development'?'/api':'/api'

export default host